import { Button } from 'ui/Button';
import styles from './GeneralNotification.module.scss';
import { ReactComponent as IconAlert } from './img/alert.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { ReactComponent as IconAlertBlue } from './img/iconAlertBlue.svg';
import { useState, useLayoutEffect } from 'react';

interface GeneralNotificationProps {
  data: {
    id?: number;
    name?: string;
    title: string;
    body: string;
    countTime?: number;
    text_button?: string;
    generalType?: boolean;
  };
  onClick?: () => void;
  styles?: string;
}

function setCookie(name: string, value: string, seconds: number) {
  const d = new Date();
  d.setTime(d.getTime() + seconds * 1000);
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let c of ca) {
    c = c.trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}
export const GeneralNotification: React.FC<GeneralNotificationProps> = ({
  data,
  onClick,
}) => {
  const [hidden, setHidden] = useState(false);

  const cookieName = `generalNotificationHidden_${data.name || data.id}`;
  const showCloseButton = data.countTime !== undefined && data.countTime !== null;

  useLayoutEffect(() => {
    if (showCloseButton && getCookie(cookieName) === 'true') {
      setHidden(true);
    }
  }, [cookieName, showCloseButton]);

  const handleClose = () => {
    if (data.countTime) {
      setCookie(cookieName, 'true', data.countTime);
    }
    setHidden(true);
  };

  if (hidden) return null;

  return (
    <div className={data?.generalType ? styles.root_general : styles.root}>
      <div className={styles.header}>
        <div className={styles.icon_and_button}>
          <div className={styles.header_left}>
            <div className={styles.svg}>
              {data?.generalType ? <IconAlertBlue /> : <IconAlert />}
            </div>
            <div className={styles.header_text}>
              <span className={styles.header_title}>{data.title}</span>
              <div className={styles.body}>
                <span>{data.body}</span>
              </div>
            </div>
          </div>
          <div className={styles.header_right} style={{ marginRight: '16px' }}>
            {data.text_button && (
              <Button
                className={styles ? styles[`${styles}`] : styles.btn}
                onClick={onClick}
                theme='filed'>
                <span style={{ paddingRight: '7px' }}>{data.text_button}</span>
              </Button>
            )}
          </div>
        </div>
        {showCloseButton && (
          <div className={styles.header_right}>
            <IconClose style={{ cursor: 'pointer' }} onClick={handleClose} />
          </div>
        )}
      </div>
    </div>
  );
};
